<template>
  <div>
    <div class="tank-info-grid-container">
      <div class="nested-1">
        <div class="form-row-input" ref="tankTypeRef">
          <ejs-dropdownlist
            float-label-type="Always"
            :dataSource="tankTypes"
            placeholder="Tank Type: *"
            :fields="fields"
            v-model="tank.tankType"
            cssClass="required"
            @change="tankTypeChange"
          />
          <label class="e-error" v-if="tankTypeMessage">{{
            tankTypeMessage
          }}</label>
        </div>

        <div class="form-row-input" ref="forUlcApiRef">
          <ejs-dropdownlist
            float-label-type="Always"
            :dataSource="constructionType"
            :fields="fields"
            placeholder="ULC/API Dropdown: *"
            :value="tank.constructionType"
            @change="onValueChange($event.value, 'constructionType')"
            cssClass="required"
          />

          <label class="e-error" v-if="ulcApiMessage">{{
            ulcApiMessage
          }}</label>
        </div>

        <div
          class="form-row-input"
          ref="forUlcApiDescRef"
          v-if="constructionTypeDesc"
        >
          <scc-input-validator
            :rules="[requiredRule]"
            :value="tank.constructionDesc"
            :showErrorLabel="showErrorConstructionDesc"
            :errorLabelMessage="constructionDescMessage"
          >
            <ejs-textbox
              float-label-type="Always"
              placeholder="ULC/API Description: *"
              v-model="tank.constructionDesc"
              @input="
                onInputChange(
                  $event.value,
                  'forUlcApiDescRef',
                  'showErrorConstructionDesc',
                  'constructionDescMessage'
                )
              "
              :multiline="true"
              cssClass="required"
              :row="5"
            />
          </scc-input-validator>
        </div>

        <div class="form-row-input" ref="tankCapacityRef">
          <scc-input-validator
            :rules="[requiredRule]"
            :number="tank.capacity"
            :showErrorLabel="showErrorCapacity"
            :errorLabelMessage="capacityMessage"
          >
            <ejs-numerictextbox
              :ref="`tankCapacity${tank.ascaTankNumber}`"
              float-label-type="Always"
              placeholder="Tank Capacity (Litres): *"
              v-model="tank.capacity"
              decimals="0"
              format="#"
              :showSpinButton="false"
              validateDecimalOnType="true"
              :maxlength="250"
              :onInput="onChangingtankCapacity()"
              cssClass="required"
            />
          </scc-input-validator>
        </div>

        <div class="form-row-input" ref="tankContentTypeRef">
          <ejs-dropdownlist
            float-label-type="Always"
            :dataSource="productTypes"
            placeholder="Type of Product Stored: *"
            :fields="fields"
            v-model="tank.contentsType"
            @change="onValueChange($event.value, 'contentsType')"
            cssClass="required"
          />

          <label class="e-error" v-if="contentsTypeMessage">{{
            contentsTypeMessage
          }}</label>
        </div>

        <div class="form-row-input" ref="reasonForRemovalRef">
          <ejs-dropdownlist
            float-label-type="Always"
            :dataSource="reasonForRemoval"
            :fields="fields"
            placeholder="Reason for Removal: *"
            v-model="tank.removalReasonType"
            @change="onValueChange($event.value, 'removalReasonType')"
            cssClass="required"
          />

          <label class="e-error" v-if="removalReasonMessage">{{
            removalReasonMessage
          }}</label>
        </div>

        <div
          class="form-row-input"
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          "
        >
          <div><b>Is piping being removed: *</b></div>
          <br />
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
            "
            ref="isPipingBeingRemovedRef"
          >
            <div>
              <ejs-radiobutton
                label="YES"
                name="pipingRemoval"
                :value="tank.isPipingBeingRemoved"
                @change="onChangeIsPipingBeingRemoved('Yes')"
                :checked="tank.isPipingBeingRemoved"
              />
            </div>
            <br />
            <div>
              <ejs-radiobutton
                label="No"
                name="pipingRemoval"
                :value="tank.isPipingBeingRemoved"
                @change="onChangeIsPipingBeingRemoved('No')"
                :checked="!tank.isPipingBeingRemoved"
              />
            </div>
          </div>
          <label class="e-error" v-if="isPipingBeingRemovedMessage">{{
            isPipingBeingRemovedMessage
          }}</label>
        </div>

        <div
          v-if="!tank.isPipingBeingRemoved"
          class="form-row-input"
          ref="isPipingRemovedDescRef"
        >
          <scc-input-validator
            :rules="[requiredRule]"
            :value="tank.pipingBeingRemovedExplain"
            :showErrorLabel="showErrorIsPipingBeingRemovedDesc"
            :errorLabelMessage="isPipingBeingRemovedDescMessage"
          >
            <ejs-textbox
              float-label-type="Always"
              placeholder="If No, Please Explain: *"
              v-model="tank.pipingBeingRemovedExplain"
              @input="
                onInputChange(
                  $event.value,
                  'isPipingRemovedDescRef',
                  'showErrorIsPipingBeingRemovedDesc',
                  'isPipingBeingRemovedDescMessage'
                )
              "
              :multiline="true"
              :row="5"
              cssClass="required"
            />
          </scc-input-validator>
        </div>
      </div>

      <div>
        <div class="span" style="display: flex; margin: -20px">
          <ejs-button
            type="button"
            cssClass="e-warning margin-button"
            v-on:click.native="deleteTank()"
          >
            <font-awesome-icon :icon="['fas', 'trash-alt']" />&nbsp;Delete
          </ejs-button>
          <!-- <ejs-button
            type="button"
            cssClass="e-success margin-button"
            v-on:click.native="copyToNewTank"
          >
            <font-awesome-icon :icon="['fas', 'file']" />&nbsp;Copy To New
          </ejs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import sccInputValidator from '../../../components/base/scc-input-validator.vue';
import { requiredRule } from '../../../shared/constants';
import { getReasonForRemoval } from '../services/permitting-api';

export default {
  components: { sccInputValidator },
  name: 'RemovalTankInfo',
  props: {
    tank: Object,
    tankIndex: Number,
    tankTypes: Array,
    constructionType: Array,
    productTypes: Array,
  },
  data() {
    return {
      fields: { value: 'message' },
      constructionTypeDesc: false,
      requiredRule,
      ulcApiMessage: null,
      constructionDescMessage: null,
      showErrorConstructionDesc: false,
      isPipingBeingRemovedMessage: null,
      capacityMessage: null,
      showErrorCapacity: false,
      contentsTypeMessage: null,
      isPipingBeingRemovedDescMessage: null,
      showErrorIsPipingBeingRemovedDesc: false,
      removalReasonMessage: null,
      reasonForRemoval: null,
      tankTypeMessage: null,
    };
  },

  computed: {
    ...mapGetters({
      permit: 'permit',
    }),
  },

  async created() {
    this.constructionTypeDesc = this.showDesc(this.tank.constructionType);
    await getReasonForRemoval().then(
      (res) => (this.reasonForRemoval = res.data),
    );
  },

  methods: {

    deleteTank() {
      const { tankIndex } = this;
      const { tank } = this;
      this.$emit('deleteTank', { tankIndex, tank });
    },

    tankTypeChange(e) {
      if (e?.value) {
        this.$refs.tankTypeRef.classList.remove('e-error');
        this.tankTypeMessage = null;
      }
    },

    // copyToNewTank() {
    //   let copiedTank = { ...this.tank };
    //   delete copiedTank.eSiteId;
    //   delete copiedTank.eTankId;
    //   this.$emit("copyToNewTank", copiedTank);
    // },

    onInputChange(val, ref, showError, message) {
      if (val) {
        this[message] = null;
        this[showError] = false;
        this.$refs[ref].classList.remove('e-error');
      }
    },

    showDesc(val) {
      return val?.toLowerCase().includes('other');
    },

    onValueChange(val, prop) {
      let refs = null;
      switch (prop) {
        case 'constructionType':
          refs = 'forUlcApiRef';
          this.ulcApiMessage = null;
          break;
        case 'contentsType':
          refs = 'tankContentTypeRef';
          this.contentsTypeMessage = null;
          break;
        case 'removalReasonType':
          refs = 'reasonForRemovalRef';
          this.removalReasonMessage = null;
          break;
      }

      this.$refs[refs].classList.remove('e-error');
      if (prop !== 'removalReasonType') {
        const showDescription = this.showDesc(val);
        this[`${prop}Desc`] = showDescription;
        this.tank[prop] = val;
      }
    },
    onChangeIsPipingBeingRemoved(val) {
      this.$refs.isPipingBeingRemovedRef.classList.remove('e-error');
      this.isPipingBeingRemovedMessage = null;
      this.tank.isPipingBeingRemoved = val == 'Yes';
    },
    onChangingtankCapacity() {
      let ref = null;
      if (this?.$refs) ref = this.$refs[`tankCapacity${this.tank.ascaTankNumber}`];
      if (ref?.$el.value) {
        this.$refs.tankCapacityRef.classList.remove('e-error');
        this.capacityMessage = null;
        this.showErrorCapacity = false;
      }
    },
  },
};
</script>
